<!--
IMPORTACAO DE TABELAS IBPT
-->

<script>
import BarList from '../components/bar-list'
import axios from 'axios'
import { SysVars } from '../main';

export default {
    data () {

        return {
            showForm: false, //exibe a tela de manutencao
            filial: '',
            codfil: '',
            metadata: this.$store.getters.getEntities.metadata,
            filter: '',
            fileList: [],
            filesResult: [],
            resultList: [],
            showSelecionaArquivos: true,
            showConfirmaImportacao: false,
            uploading: false,
            reRenderList: 0,
            showImportacaoFinalizada: false,
        }
    },

    computed: {
        qtFiles: function () {
            return this.fileList.length
        },
    },

    filters: {
    },

    methods: {
        handleImportacaoFinalizada () {
            let finished = this.fileList.length > 0
            for( var i = 0; i < this.fileList.length; i++ ){
                if (!this.fileList[i].finished)
                  finished = false
            }
            this.showImportacaoFinalizada = finished
            this.uploading = !this.showImportacaoFinalizada
        },

        handleFileSelectBtn() {
            //BOTAO SELECIONAR ARQUIVOS
            this.$refs.file.value = ''            
            this.$refs.file.click()
        },

        handleFileUpload () {
            //EVENTO AO SELECIONAR ARQUIVOS
            //EFETUA A LEITURA DE CADA ARQUIVO SELECIONADO ATRAVES DO SERVIDOR (SERVIDOR RETORNA O XML)

            //console.log(this.$refs.file.files)
            
            this.fileList = []
            var files = this.$refs.file.files
            this.filesResult = []

            for( var i = 0; i < files.length; i++ ){
                let file = files[i]
                file.finished = false
                file.uploading = false
                this.fileList.push(file)
            }

            if (files.length > 30) {
               this.$erpToastError('Seleção não permitida. O limite máximo é de 30 arquivos por importação.')
               return 
            }

            this.showSelecionaArquivos = false
            this.showConfirmaImportacao = true
            this.uploading = false
        },

        readCSV(csvContent, filename, fileIdx) {
            let self = this

            let estado = filename.substring(12,14)

            this.fileList[fileIdx].uploading = true
            this.reRenderList += 1  //re render

            let formData = new FormData()
            formData.append('file', new Blob([csvContent]), filename)

            var path = this.$store.getters.urlApp + 'ibpt/importa/' + estado

            axios.post(path, formData,
                { timeout: 1000 * 120, headers: { 'Content-Type': 'multipart/form-data' } }
            ).then(function(data){
                    let addfile = { filename: filename, result: data.data }
                    self.filesResult.push(addfile)
                    self.fileList[fileIdx].uploading = false
                    self.fileList[fileIdx].finished = true
                    if (addfile.result.errormessages.length)
                      self.fileList[fileIdx].errors = addfile.result.errormessages.length
                    else
                      self.fileList[fileIdx].gravados = addfile.result.gravados
                    self.reRenderList += 1  //re render
                    self.handleImportacaoFinalizada()
                })
                // .catch(function(data){
                //     self.$erpToastError('Erro ao efetuar upload do arquivo ' + filename + ': ' + data)
                // })
        },

        handleNovaImportacao () {
            this.showImportacaoFinalizada = false
            this.showConfirmaImportacao = false
            this.showSelecionaArquivos = true
            this.uploading = false
        },

        handleExecutaImportacao () {
            this.uploading = true

            var files = this.$refs.file.files
            let self = this

            //formData.append('file', this.selectedFile)
            for( var i = 0; i < files.length; i++ ){
                let file = files[i]
                let idx = i
                let reader = new FileReader()
                reader.readAsText(file, 'ISO-8859-1')
                reader.onload = function (event) {
                    let content = event.target.result
                    self.readCSV(content, file.name, idx)
                }
            }

        //     //ENVIA O OBJETO JSON PARA IMPORTAÇÃO
        //     //RETORNA UM OBJETO ARRAY COM A SITUACAO DE CADA ITEM IMPORTADO E OS ERROS SE HOUVER
        //     //[ filename: "", status: "ok", errormessage: "", text: ""]

        //     let sendData = { xmls: this.filesResult }
        //     this.resultList = []

        //     var self = this

        //     axios.post(urlORDS(this.$store, 'cg/importxml/'), sendData, {})
        //         .then(function(data){
        //             // console.log(data.data)
        //             self.transcount = data.data.transcount
        //             self.forncount = data.data.forncount
        //             self.prodcount = data.data.prodcount
        //             self.clicount = data.data.clicount
        //             self.resultList = data.data.result
        //             self.$erpToastSuccess('Importação executada')
        //             self.showConfirmaImportacao = false
        //         })
        //         .catch(function(data){
        //             self.$erpToastError('Erro ao efetuar importação ' + data.message)
        //         })
        },

        async loadData() {
        },

        handleRetornar () {
            this.resultList = []
            this.showSelecionaArquivos = true
            this.showConfirmaImportacao = false
        },

    },

    components: {
        BarList
    },

    created () {
        this.loadData()
    }

}

</script>

<template> 
    <div>
        <bar-manut 
            single-entity="Importação de Tabelas IBPT" 
            :disableSave="true"
            :disableRetorno="true">
        </bar-manut>

        <div class="default-container" v-if="showSelecionaArquivos">
            <label-title title="Selecionar Arquivos CSV" class="mb-2"></label-title>
            <span class="w-100 lbl">Importação de tabelas IBPT</span>
            <hr>
            <div class="row mt-5 mb-5">
                <!-- <div class="col-md-12">
                    <span class="w-100 lbl-edit">A importação de dados é feita através dos arquivos XML de notas fiscais da sua Empresa</span>
                    <span class="w-100 lbl-edit">Selecione até 50 arquivos de XML</span>
                </div> -->
                <div class="col-md-12 mt-2">
                </div>
                <div class="col-md-12 mt-2">
                    <!-- <alert v-if="errmessage" type="warning" title="Erro na importação do arquivo" :text="errmessage"></alert> -->
                </div>
            </div>
            <hr>
            <div class="row">
                <div class="col-md-12 mt-2">
                    <v-button label="Selecionar Arquivos" :nb-btdef="false" icon="fa-upload" @click="handleFileSelectBtn()"></v-button>
                </div>
            </div>
        </div>

        <div class="default-container" v-if="showConfirmaImportacao" :key="reRenderList">
            <label-title title="Confirmar Importação" class="mb-2" v-if="!uploading && !showImportacaoFinalizada"></label-title>
            <label-title title="Importação em Andamento" class="mb-2" v-if="uploading"></label-title>
            <label-title title="Importação Finalizada" class="mb-2" v-if="showImportacaoFinalizada"></label-title>
            <hr>
            <div class="row mt-5">

            </div>

            <div class="row align-items-center" v-for="(file, index) in fileList" v-bind:key="index">
                <div class="col-md-3 col-4">
                    <span class="data-list">{{ file.name }}</span>
                </div>
                <div class="col-md-9 col-10" v-if=file.finished>
                    <span v-if="!file.errors"> <i class="fa fa-check" aria-hidden="true"></i> upload concluído </span>
                    <span v-if="!file.errors"> Quantidade de linhas importadas: {{ file.gravados }} </span>
                    <span v-if="file.errors"> <i class="error fa fa-warning" aria-hidden="true"></i> upload concluído com erros </span>
                </div>
                <div class="col-md-4 col-6" v-if="file.uploading">
                    <div class="spinner-border text-muted">
                    </div>
                </div>
            </div>

            <div class="row mt-5" v-if="!uploading">
                <div class="col-md-12">
                    <span class="w-100 lbl-edit">Confirme a importação de {{ qtFiles }} arquivos XML</span>
                </div>
            </div>

            <hr>
            <div class="row" v-if="!uploading && !showImportacaoFinalizada">
                <div class="col-md-12 mt-2">
                    <v-button label="Continuar" :nb-btdef="true" @click="handleExecutaImportacao()"></v-button>
                    <v-button label="Cancelar" @click="handleRetornar()"></v-button>
                </div>
            </div>
            <div class="row" v-if="uploading && !showImportacaoFinalizada">
                <div class="col-md-12 mt-2">
                    <span class="w-100 lbl-edit">Importação em andamento!</span>
                </div>
            </div>
            <div class="row" v-if="showImportacaoFinalizada">
                <div class="col-md-12 mt-2">
                    <v-button label="Efetuar Nova Importação" @click="handleNovaImportacao()"></v-button>
                </div>
            </div>
        </div>
        
        <div v-show="false" class="row">
            <div class="col">
                <label>
                        <input type="file" ref="file" multiple accept=".csv" @change="handleFileUpload()">
                </label>
            </div>
        </div>


    </div>


</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/importa-ibpt.vue